import { createContext, useContext, useMemo, useState } from "react";
import { SiteState } from "./state-models";
import React from "react";

type SiteContextType = {
    siteState: SiteState;
} | null;

export const SiteStateContext = createContext<SiteContextType | undefined>(undefined);

type SiteStateProviderProps = {
    children: React.ReactNode;
    initialState?: SiteState;
};

export const SiteStateProvider = ({ children, initialState = {} }: SiteStateProviderProps) => {
    const [state] = useState<SiteState>(initialState);

    // Memoize the context value to prevent unnecessary re-renders
    const contextValue = useMemo(() => ({ siteState: state }), [state]);

    return <SiteStateContext.Provider value={contextValue}>{children}</SiteStateContext.Provider>;
};

// Custom hook to use the context
export const useSiteContext = () => {
    const context = useContext(SiteStateContext);
    if (!context) {
        throw new Error("useSiteContext must be used within a SiteStateProvider");
    }

    return useMemo(() => context, [context]);
};